import { render, staticRenderFns } from "./valuecodeList.vue?vue&type=template&id=719b31c6&"
import script from "./valuecodeList.vue?vue&type=script&lang=js&"
export * from "./valuecodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports